/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Category } from './';
import {
    CategoryFromJSON,
    CategoryFromJSONTyped,
    CategoryToJSON,
} from './';
import type { ExperienceLevel } from './';
import {
    ExperienceLevelFromJSON,
    ExperienceLevelFromJSONTyped,
    ExperienceLevelToJSON,
} from './';
import type { FunctionalScope } from './';
import {
    FunctionalScopeFromJSON,
    FunctionalScopeFromJSONTyped,
    FunctionalScopeToJSON,
} from './';
import type { IndustryExpertise } from './';
import {
    IndustryExpertiseFromJSON,
    IndustryExpertiseFromJSONTyped,
    IndustryExpertiseToJSON,
} from './';
import type { JobTitle } from './';
import {
    JobTitleFromJSON,
    JobTitleFromJSONTyped,
    JobTitleToJSON,
} from './';
import type { Language } from './';
import {
    LanguageFromJSON,
    LanguageFromJSONTyped,
    LanguageToJSON,
} from './';
import type { Skill } from './';
import {
    SkillFromJSON,
    SkillFromJSONTyped,
    SkillToJSON,
} from './';

/**
 * 
 * @export
 * @interface Profile
 */
export interface Profile {
    /**
     * 
     * @type {JobTitle}
     * @memberof Profile
     */
    jobTitle: JobTitle;
    /**
     * 
     * @type {Category}
     * @memberof Profile
     */
    category: Category;
    /**
     * 
     * @type {ExperienceLevel}
     * @memberof Profile
     */
    experience: ExperienceLevel;
    /**
     * 
     * @type {Array<Language>}
     * @memberof Profile
     */
    languages: Array<Language>;
    /**
     * 
     * @type {Array<Skill>}
     * @memberof Profile
     */
    skills: Array<Skill>;
    /**
     * 
     * @type {Array<Skill>}
     * @memberof Profile
     */
    mandatorySkills: Array<Skill>;
    /**
     * 
     * @type {Array<Skill>}
     * @memberof Profile
     */
    bonusSkills: Array<Skill>;
    /**
     * 
     * @type {Array<FunctionalScope>}
     * @memberof Profile
     */
    functionalScopes: Array<FunctionalScope>;
    /**
     * 
     * @type {Array<IndustryExpertise>}
     * @memberof Profile
     */
    industryExpertises: Array<IndustryExpertise>;
}

/**
 * Check if a given object implements the Profile interface.
 */
export function instanceOfProfile(value: object): value is Profile {
    if (!('jobTitle' in value) || value['jobTitle'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('experience' in value) || value['experience'] === undefined) return false;
    if (!('languages' in value) || value['languages'] === undefined) return false;
    if (!('skills' in value) || value['skills'] === undefined) return false;
    if (!('mandatorySkills' in value) || value['mandatorySkills'] === undefined) return false;
    if (!('bonusSkills' in value) || value['bonusSkills'] === undefined) return false;
    if (!('functionalScopes' in value) || value['functionalScopes'] === undefined) return false;
    if (!('industryExpertises' in value) || value['industryExpertises'] === undefined) return false;
    return true;
}

export function ProfileFromJSON(json: any): Profile {
    return ProfileFromJSONTyped(json, false);
}

export function ProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): Profile {
    if (json == null) {
        return json;
    }
    return {
        
        'jobTitle': JobTitleFromJSON(json['jobTitle']),
        'category': CategoryFromJSON(json['category']),
        'experience': ExperienceLevelFromJSON(json['experience']),
        'languages': ((json['languages'] as Array<any>).map(LanguageFromJSON)),
        'skills': ((json['skills'] as Array<any>).map(SkillFromJSON)),
        'mandatorySkills': ((json['mandatorySkills'] as Array<any>).map(SkillFromJSON)),
        'bonusSkills': ((json['bonusSkills'] as Array<any>).map(SkillFromJSON)),
        'functionalScopes': ((json['functionalScopes'] as Array<any>).map(FunctionalScopeFromJSON)),
        'industryExpertises': ((json['industryExpertises'] as Array<any>).map(IndustryExpertiseFromJSON)),
    };
}

export function ProfileToJSON(value?: Profile | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'jobTitle': JobTitleToJSON(value['jobTitle']),
        'category': CategoryToJSON(value['category']),
        'experience': ExperienceLevelToJSON(value['experience']),
        'languages': ((value['languages'] as Array<any>).map((v) => LanguageToJSON(v))),
        'skills': ((value['skills'] as Array<any>).map((v) => SkillToJSON(v))),
        'mandatorySkills': ((value['mandatorySkills'] as Array<any>).map((v) => SkillToJSON(v))),
        'bonusSkills': ((value['bonusSkills'] as Array<any>).map((v) => SkillToJSON(v))),
        'functionalScopes': ((value['functionalScopes'] as Array<any>).map((v) => FunctionalScopeToJSON(v))),
        'industryExpertises': ((value['industryExpertises'] as Array<any>).map((v) => IndustryExpertiseToJSON(v))),
    };
}

